/**
 * Generated by orval 🍺
 * Do not edit manually.
 * ViridisChem API
 * API documentation for ViridisChem API
 */

/**
 * Regulatory profile and output language used to generate one SDS.
 */
export type SdsProfileId = (typeof SdsProfileId)[keyof typeof SdsProfileId];

export const SdsProfileId = {
    /** United States OSHA Hazard Communication Standard 2024 in US English. */
    US_OSHA_HAZCOM_EN_US: "US_OSHA_HAZCOM_EN_US",
    /** Canadian WHMIS and Hazardous Products Regulations Canadian English part. Supplier compliance also requires the corresponding Canadian French part. */
    CA_WHMIS_HPR_EN_CA: "CA_WHMIS_HPR_EN_CA",
    /** Canadian WHMIS and Hazardous Products Regulations Canadian French part. Supplier compliance also requires the corresponding Canadian English part. */
    CA_WHMIS_HPR_FR_CA: "CA_WHMIS_HPR_FR_CA",
    /** EU REACH Annex II and CLP requirements for Germany in German. */
    EU_REACH_CLP_DE_DE: "EU_REACH_CLP_DE_DE",
    /** Australian model WHS SDS requirements using GHS Revision 7 in Australian English. */
    AU_MODEL_WHS_GHS7_EN_AU: "AU_MODEL_WHS_GHS7_EN_AU",
    /** Japanese JIS Z 7252:2025 and JIS Z 7253:2025 requirements in Japanese. */
    JP_JIS_7252_7253_JA_JP: "JP_JIS_7252_7253_JA_JP",
} as const;
